export default "__VITE_PUBLIC_ASSET__1915d897__"